/* 100ks, pojistka předprodeje (2026-10-29).
   Pravidlo: ke každému tisku z předprodeje musí být v košíku přesně jedno číslo edice
   (počet kusů tisku = počet čísel) a žádné číslo nesmí být v košíku bez tisku.
   Pojistka košík sama srovná: přebytečné kusy tisku ubere, tisk bez čísla odebere,
   přebytečná nebo osiřelá čísla odebere. Běží po každé změně košíku, při načtení stránky
   košíku a těsně před odchodem do pokladny (tlačítka Pokladna na stránce košíku,
   v oznámení o přidání do košíku i v šuplíku košíku).
   Data: /cart.js (položky) a sekce ks-presale-map (která edice patří ke kterému produktu s čísly). */
(function () {
  'use strict';
  if (window.KsPresaleGuard) return;

  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var changeUrl = routes.cart_change_url || '/cart/change';
  var checkoutUrl = cartUrl.replace(/\/cart\/?$/, '/checkout');
  var T = window.ksPresaleStrings || {};
  var NOTICE_KEY = 'ksPresaleNotice';
  var RELOAD_KEY = 'ksPresaleReloads';
  var running = null;
  var again = false;

  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }

  function getCart() {
    return fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  function getMap() {
    return fetch(cartUrl + '?section_id=ks-presale-map', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('map'); return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ks-presale-map]');
        if (!el) throw new Error('map');
        return JSON.parse(el.textContent);
      });
  }

  function change(key, quantity) {
    return fetch(changeUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  /* Spočítá, co je v košíku špatně, a vrátí seznam změn (klíč řádku + nové množství). */
  function plan(cart, map) {
    var items = cart.items || [];
    var prints = (map && map.prints) || {};
    var changes = [];
    var info = { removedPrints: [], loweredPrints: [], removedNumbers: 0 };
    var numberIds = {};
    Object.keys(prints).forEach(function (pid) { numberIds[String(prints[pid])] = true; });

    Object.keys(prints).forEach(function (pid) {
      var nid = String(prints[pid]);
      var printLines = items.filter(function (it) { return String(it.product_id) === pid; });
      var numLines = items.filter(function (it) { return String(it.product_id) === nid; });
      var printQty = printLines.reduce(function (s, it) { return s + it.quantity; }, 0);
      var numQty = numLines.reduce(function (s, it) { return s + it.quantity; }, 0);
      var i, line, take, left;
      if (printQty > numQty) {
        left = printQty - numQty;
        for (i = printLines.length - 1; i >= 0 && left > 0; i--) {
          line = printLines[i];
          take = Math.min(line.quantity, left);
          changes.push({ key: line.key, quantity: line.quantity - take });
          (line.quantity - take === 0 ? info.removedPrints : info.loweredPrints).push(line.product_title);
          left -= take;
        }
      } else if (numQty > printQty) {
        left = numQty - printQty;
        for (i = numLines.length - 1; i >= 0 && left > 0; i--) {
          line = numLines[i];
          take = Math.min(line.quantity, left);
          changes.push({ key: line.key, quantity: line.quantity - take });
          info.removedNumbers += take;
          left -= take;
        }
      }
    });

    items.forEach(function (it) {
      if (it.product_type === 'presell' && !numberIds[String(it.product_id)]) {
        changes.push({ key: it.key, quantity: 0 });
        info.removedNumbers += it.quantity;
      }
    });

    return { changes: changes, info: info };
  }

  function load() { return Promise.all([getCart(), getMap()]); }

  function runOnce() {
    return load().catch(function () { return load(); })
      .then(function (res) {
        var cart = res[0], map = res[1];
        if (!cart || !cart.item_count) return { changed: false, info: null };
        var p = plan(cart, map);
        if (!p.changes.length) return { changed: false, info: p.info };
        return p.changes.reduce(function (q, c) {
          return q.then(function () { return change(c.key, c.quantity); });
        }, Promise.resolve()).then(function () { return { changed: true, info: p.info }; });
      })
      .catch(function () { return { changed: false, info: null, error: true }; });
  }

  /* Jedna kontrola najednou; požadavek během běhu se zopakuje po doběhnutí. */
  function sync() {
    if (running) { again = true; return running; }
    running = runOnce().then(function (res) {
      running = null;
      if (again) {
        again = false;
        return sync().then(function (r2) {
          return { changed: res.changed || r2.changed, info: res.info || r2.info, error: r2.error };
        });
      }
      return res;
    });
    return running;
  }

  function message(info) {
    if (!info) return '';
    var parts = [];
    if (info.removedPrints.length && T.missing) parts.push(T.missing.replace('%s', uniq(info.removedPrints).join(', ')));
    if (info.loweredPrints.length && T.lowered) parts.push(T.lowered.replace('%s', uniq(info.loweredPrints).join(', ')));
    if (!parts.length && info.removedNumbers && T.numbers) parts.push(T.numbers);
    return parts.join(' ');
  }

  function isCartPage() { return !!document.getElementById('main-cart-items'); }

  function showNotice(msg) {
    var box = document.querySelector('[data-ks-presale-notice]');
    if (!box || !msg) return;
    box.textContent = msg;
    box.hidden = false;
    try { box.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }

  function refreshBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch(cartUrl + '?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      }).catch(function () {});
  }

  /* Po opravě: na stránce košíku znovu načíst (a ukázat zprávu), před pokladnou poslat do košíku,
     jinde jen přepočítat ikonu košíku. Proti smyčce reloadů je počítadlo. */
  function afterFix(info, toCart) {
    var msg = message(info);
    try { if (msg) sessionStorage.setItem(NOTICE_KEY, msg); } catch (e) {}
    if (isCartPage()) {
      var n = 0;
      try { n = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10); sessionStorage.setItem(RELOAD_KEY, String(n + 1)); } catch (e) {}
      if (n < 3) { window.location.reload(); return; }
      showNotice(msg || T.locked || '');
      return;
    }
    if (toCart) { window.location.href = cartUrl; return; }
    refreshBubble();
  }

  /* Pokladna: každé odeslání s tlačítkem „checkout“ nejdřív projde kontrolou. */
  var CART_FORMS = { cart: 1, 'CartDrawer-Form': 1, 'cart-notification-form': 1 };
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;
    var sub = evt.submitter || null;
    var isCheckout = (sub && sub.name === 'checkout') || (!sub && CART_FORMS[form.id]);
    if (!isCheckout) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var btn = sub || form.querySelector('[name="checkout"]') || document.querySelector('[name="checkout"][form="' + form.id + '"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    sync().then(function (res) {
      if (res.changed) { afterFix(res.info, true); return; }
      window.location.href = checkoutUrl;
    });
  }, true);

  function init() {
    var pending = '';
    try { pending = sessionStorage.getItem(NOTICE_KEY) || ''; if (pending) sessionStorage.removeItem(NOTICE_KEY); } catch (e) {}
    if (pending) showNotice(pending);

    if (isCartPage()) {
      sync().then(function (res) {
        if (res.changed) { afterFix(res.info, false); return; }
        try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'ks-presale-guard') return;
        sync().then(function (res) { if (res.changed) afterFix(res.info, false); });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.KsPresaleGuard = { sync: sync, plan: plan };
})();
